import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { isFlexSelector, isOccasionSelector } from '../store/selectors';
import { GaFunnelInfo } from '../types/gaFunnelInfo';
import { getCurrentStep, getCurrentStepNumber } from '../utils/navigation';

export const useGaFunnelInfo = (): GaFunnelInfo => {
	const isFlex = useSelector(isFlexSelector);
	const isOccasion = useSelector(isOccasionSelector);
	const currentStep = getCurrentStep();
	const currentStepNumber = getCurrentStepNumber();

	const [gaFunnelInfo, setGaFunnelInfo] = useState({
		funnel_name: '',
		funnel_step: '',
		funnel_index: '',
	});

	useEffect(() => {
		setGaFunnelInfo({
			funnel_name: `private-lease-${isFlex ? 'flex' : isOccasion ? 'occasion' : 'nieuw'}`,
			funnel_step: currentStep,
			funnel_index: currentStepNumber.toString(),
		});
	}, [currentStep, currentStepNumber, isFlex, isOccasion]);

	return gaFunnelInfo;
};
